export type WorkType = "movie" | "tv" | "variety";

export interface Episode {
  index: number;
  title: string;
  summary: string;
}

export interface Work {
  id: string;
  type: WorkType;
  title: string;
  cover: string;
  banner: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  description: string;
  views: number;
  tags: string[];
  featured?: boolean;
  episodes?: Episode[];
}

export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  category: string;
  author: string;
  views: number;
  tags: string[];
  content: string[];
}

export interface CategoryMeta {
  key: WorkType;
  name: string;
  path: string;
  description: string;
  icon: string;
}

export const WORK_TYPE_LABEL: Record<WorkType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};